import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import authService from "../Services/authService";
import analytics from "../Services/analyticsService";
import { IS_VATAR } from "../vatar/env";
import { SIGNUP_NUDGE_COPY } from "../utils/hostingCopy";

const CHANCE = 0.3;
const COOLDOWN_MS = 24 * 60 * 60 * 1000;
const KEY = "signupNudgeAt";

function recentlyShown() {
  try {
    return Date.now() - Number(localStorage.getItem(KEY) || 0) < COOLDOWN_MS;
  } catch {
    return false;
  }
}

// An occasional card asking guests to sign up for the 150 coins. Only shown
// while the bonus is switched on, so it never promises coins that are not paid.
const SignupNudge = ({ onSignUp }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (IS_VATAR || recentlyShown() || Math.random() >= CHANCE) return undefined;
    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        await authService.waitForInit();
        const user = authService.auth.currentUser;
        if (user && !user.isAnonymous) return;
        const config = await getDoc(doc(db, "appConfig", "welcomeBonus"));
        if (cancelled || !config.exists() || config.data().enabled !== true) return;
        try {
          localStorage.setItem(KEY, String(Date.now()));
        } catch {
          // storage unavailable: the card just may show again
        }
        analytics.track("signup_nudge_shown", {});
        setVisible(true);
      } catch (error) {
        console.error("Sign-up nudge skipped:", error);
      }
    }, 4000);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, []);

  if (!visible) return null;
  return (
    <div role="dialog" aria-label={SIGNUP_NUDGE_COPY.title} className="fixed inset-x-4 bottom-4 z-40 mx-auto max-w-sm rounded-2xl bg-white p-4 shadow-xl border border-amber-200">
      <p className="font-bold text-gray-900">{SIGNUP_NUDGE_COPY.title}</p>
      <p className="mt-0.5 text-sm text-gray-600">{SIGNUP_NUDGE_COPY.body}</p>
      <div className="mt-3 flex gap-2">
        <button
          type="button"
          onClick={() => {
            analytics.track("signup_nudge_clicked", {});
            setVisible(false);
            onSignUp();
          }}
          className="flex-1 rounded-xl bg-red-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-red-700"
        >
          {SIGNUP_NUDGE_COPY.button}
        </button>
        <button type="button" onClick={() => setVisible(false)} className="flex-1 rounded-xl px-4 py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-50">
          {SIGNUP_NUDGE_COPY.later}
        </button>
      </div>
    </div>
  );
};

export default SignupNudge;
